export default __webpack_public_path__ + "static/media/loading.40d84ec7.svg";